export default __webpack_public_path__ + "static/media/Mark-3-3D-Model-01.c3706755.jpg";